import { ConcreteMeasure } from "./Measure";
import { MeasureType } from "./MeasureType";

export class AngleMeasure extends ConcreteMeasure {
    constructor() {
        super();
        this.type = MeasureType.ANGLE;
    }
}